import { HalfPieChart } from "half-pie-chart";
import React, { Component } from "react";

class PaidOut extends Component {
	constructor(props) {
		super(props);
		const vft = this.props.vft;
		const usdt = this.props.usdt;
		this.state = {
			right: [
				{
					value: vft,
					color: "#3aa8ef",
				},
			],
			left: [
				{
					value: usdt,
					color: "#ee6d50",
				},
			],
		};
	}
	render() {
		return (
			<HalfPieChart
				name="rentStatus2"
				right={this.state.right}
				left={this.state.left}
				dark={true}
			/>
		);
	}
}
export default PaidOut;
